module.exports = __webpack_public_path__ + "static/runningDashboard-9a89032a2734924bdf147ba2972829aa.png";